export const reservationKeys = {
  all: ["reservation"],
  list: () => [...reservationKeys.all, "list"],
  vacationHomes: () => [...reservationKeys.all, "vacation-homes"],
};
